if (!process.env.VUE_APP_IS_WEB) {
  var ContactDB = require("../database/models/Contact");
}

import ContactORM from "@/store/orm-axios/models/Contact";

export default {
  FETCH(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ContactDB()
          .query({ where: { building_id: buildingId, deleted: null } })
          .fetchAll()
          .then(res => {
            ContactORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ContactORM.api()
          .FETCH(buildingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ContactDB({ id: item.id })
          .save({ label: item.label }, { isUpdate: true })
          .then(res => {
            var data = res.serialize();
            ContactORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ContactORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new ContactDB(itemPost)
          .save()
          .then(res => {
            ContactORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        ContactORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER(item) {
    return new Promise((resolve, reject) => {
      ContactORM.api()
        .REGISTER(
          JSON.stringify({
            email: item.email,
            generate: true,
            timezone: localStorage.getItem("timezone"),
          })
        )
        .then(res => {
          resolve(res.response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  REGISTER_GET_CONTACTS(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        ContactORM.api()
          .REGISTER_GET_CONTACTS(meetingId)
          .then(res => {
            ContactORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
